import React, { useRef } from 'react';
var VeltCommentsSidebarV2Panel = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-panel-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2Panel;
